import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18BoldG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M4.52 4.17a.9.9 0 0 1 .9-.9h4.09l.124-.014a3.32 3.32 0 0 1 2.718 5.555 3.32 3.32 0 0 1-1.913 5.883l-.189.006H5.42a.9.9 0 0 1-.893-.787L4.52 13.8zm4.999 5.69H6.32v3.04h3.93a1.52 1.52 0 0 0 1.514-1.382l.006-.138a1.52 1.52 0 0 0-1.382-1.514l-.101-.003c-.28.033-.568.03-.856-.012l.038.003zm.653-1.798a1.52 1.52 0 0 0-.483-3.001l-.129.009H6.32v2.99z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18BoldG$1 = Svg18BoldG;

export { Svg18BoldG$1 as default };
